import { Link } from '@tanstack/react-router';
import styled from 'styled-components';

import { DemandInformationCategory, DemandInformationVessel } from '../../../../types/DemandInformationMessage';
import { linkStyles } from '../../../cdl/Link/linkStyles';
import { HumanReadableEnumValue } from '../../../common/enums/HumanReadableEnumValue';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import { theme } from '../../../common/ui/theme';
import { getMatchingDemandOffer } from '../../utils/getMatchingDemandOffer';

const SmallLink = styled(Link as any)<{ fontSize: string }>`
    ${linkStyles};
`;

interface ProductValueProps {
    row: DemandInformationCategory;
    vessel: DemandInformationVessel;
}

export const ProductValue = ({ row, vessel }: ProductValueProps) => {
    const offerId = getMatchingDemandOffer(row, vessel)?.id;

    return (
        <Box display="flex">
            <HumanReadableEnumValue enumType="vesselTankCategory" value={row.tankCategory} />
            {offerId ? (
                <Box marginLeft={8}>
                    <SmallLink fontSize={theme.fontSizes[12]} to="/offer/$id" params={{ id: offerId }}>
                        {translate('demand.showOrder')}
                    </SmallLink>
                </Box>
            ) : null}
        </Box>
    );
};
